/** Class helpers for the v5 order screens (Omni's selectable card + source tags). */
import { createContext } from 'react';
import { cn } from '@/components/ui/utils';

/** The step nav, shown on the right of every step's page header. */
export const StepsSlot = createContext<React.ReactNode>(null);

export const tile = (on: boolean) => cn('flex min-h-[44px] flex-col gap-1 rounded-xl border bg-white p-3.5 text-left transition-all', on ? 'border-[#be43ff] bg-[#be43ff]/[0.04] shadow-sm' : 'border-[#eaecf0] hover:border-[#be43ff]/40 hover:bg-[#fcf7ff]');

export const SOURCE_LABEL: Record<string, string> = { you: 'You', brand_os: 'Brand OS', plan: 'Plan', standard: 'Standard', beatly: 'Beatly', ask: 'Needed', after: 'After the order' };
export const SOURCE_CLS: Record<string, string> = {
  you: 'bg-[#be43ff]/8 text-[#be43ff]', brand_os: 'bg-[#2e024c]/8 text-[#2e024c]', plan: 'bg-[#f2f4f7] text-[#344054]', standard: 'bg-[#f2f4f7] text-[#667085]',
  beatly: 'bg-[#f2f4f7] text-[#667085]', ask: 'bg-[#fef3f2] text-[#b42318]', after: 'bg-[#f2f4f7] text-[#344054]',
};
